// directive
//   <scoreboard-diagnostics-status scoreboard-configuration="scoreboardConfiguration" stream-diagnostics="streamDiagnostics" />
//
angular.module('app.directives').component('scoreboardDiagnosticsStatus', {
  restrict: 'E',
  bindings: {
    scoreboardConfiguration: '=',
    streamDiagnostics: '=',
  },
  template: require('./scoreboard-diagnostics-status.html'),
  controllerAs: 'vm',
  controller: function ScoreboardDiagnosticsStatusController($scope) {
    'ngInject';

    const recalculate = () => {
      this.usingScoreboardAssist =
        (this.scoreboardConfiguration || {}).scoreboard_make == 'BoxCast';
      this.scoreboardMode = (
        ((this.streamDiagnostics || {}).scoreboard || {}).scoreboard_assist || {}
      ).operation_mode;
      this.serialPortIsOpen = (this.streamDiagnostics || {}).serial_port_is_open;
      this.serialPortIsOpenStyle =
        this.serialPortIsOpen == undefined ? { 'font-style': 'italic', color: '#848484' } : {};
      this.scoreboardAssistLinked = (this.streamDiagnostics || {}).scoreboard_assist_linked;
      this.scoreboardAssistLinkedStyle =
        this.scoreboardAssistLinked == undefined
          ? { 'font-style': 'italic', color: '#848484' }
          : {};
      this.scoreboardAssistConnected = (this.streamDiagnostics || {}).scoreboard_assist_connected;
      this.scoreboardAssistConnectedStyle =
        this.scoreboardAssistConnected == undefined
          ? { 'font-style': 'italic', color: '#848484' }
          : {};
      this.receivingScoreboardData = (this.streamDiagnostics || {}).receiving_scoreboard_data;
      this.receivingScoreboardDataStyle =
        this.receivingScoreboardData == undefined
          ? { 'font-style': 'italic', color: '#848484' }
          : {};
      this.decodeErrors = (this.streamDiagnostics || {}).scoreboard_data_decode_errors;
      this.decodeErrorsStyle =
        this.decodeErrors == undefined ? { 'font-style': 'italic', color: '#848484' } : {};
    };
    $scope.$watchGroup(['scoreboardConfiguration', 'streamDiagnostics'], recalculate);
    recalculate();
  },
});



// WEBPACK FOOTER //
// ./app/directives/scoreboard-diagnostics-status.js